const INITIAL_STATE = {
	aguardando: false,
	registro: {},
	modoTela: 'lista',
	lista: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'APP_RASTREIO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'APP_RASTREIO_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'APP_RASTREIO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

        default:
            return state;
    }
}
